import React, { useState } from 'react';

import { Typography } from 'antd';

import { showLog } from '@libs/NwMoment';

import { useLayoutContext } from '@contexts/LayoutContext';

import ModelDrawer from '@components/ContactDetails/ModelDetails/Drawer/ModelDrawer';
import { NwButton } from '@components/Gui/NwButton';
import { NwCard } from '@components/Gui/NwCard/NwCard';
import NwClipboardCopyText from '@components/Gui/NwClipboardCopyText';
import NwIcon from '@components/Gui/NwIcon';
import NwLink from '@components/Gui/NwLink';
import PackageShortlist from '@components/PackageDrawer/PackageShortlist';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const { Text } = Typography;

const PackageRecipientsSummary = ({ recipients, isSent, onGetAnonymousLink, onOpenAddRecipients }) => {
    const [selectedShortlistItem, setSelectedShortlistItem] = useState(null);

    const onSelectShortlistItem = (modelID) => {
        setSelectedShortlistItem(modelID);
    };

    const { isMobile } = useLayoutContext();

    return (
        <div className="package-drawer-recipients-container">
            <NwCard
                icon={byPrefixAndName.fasl['mailbox']}
                title="Recipients"
                extra={
                    <div className="actions-group-holder">
                        <NwButton
                            primary
                            lowercase
                            icon={byPrefixAndName.fasl['link']}
                            label={isMobile ? 'get link' : 'get link (no tracking)'}
                            onClick={onGetAnonymousLink}
                            disabled={isSent}
                        />
                        <NwButton
                            primary
                            lowercase
                            icon={byPrefixAndName.fasl['mailbox']}
                            label={isMobile ? 'add' : 'add recipients'}
                            disabled={isSent}
                            onClick={onOpenAddRecipients}
                        />
                    </div>
                }
            >
                {recipients.length === 0 && <p style={{ paddingLeft: '2.25rem' }}>no recipients yet</p>}
                {recipients.map((recipient, index) => {
                    const iconClassName = `recipient-icon ${recipient.HasRecipientOpenPackage && ' recipient-icon-done'}`;
                    const iconType = recipient.HasRecipientOpenPackage
                        ? byPrefixAndName.fasds['circle-check']
                        : byPrefixAndName.fasl['circle-check'];
                    return (
                        <div className="package-drawer-recipient" key={index}>
                            <div className="package-drawer-recipient-line">
                                <div className="package-drawer-recipient-icon">
                                    <NwIcon icon={iconType} className={iconClassName} />
                                </div>
                                <div className="package-drawer-recipient-email">
                                    <p>{recipient.Email}</p>
                                </div>
                                <div className="package-drawer-recipient-date">
                                    {recipient.HasRecipientOpenPackage &&
                                    recipient.LastRecipientOpensPackageDateTime ? (
                                        <p>last visit: {showLog(recipient.LastRecipientOpensPackageDateTime)}</p>
                                    ) : (
                                        <p className="not-visited">
                                            <NwIcon icon={byPrefixAndName.fasl['hourglass']} />
                                            not visited
                                        </p>
                                    )}
                                </div>
                                <div className="package-drawer-recipient-link">
                                    <p>
                                        <NwLink
                                            target="_blank"
                                            rel="noreferrer"
                                            onClick={() => {
                                                window.open(recipient.Link);
                                            }}
                                        >
                                            <NwIcon icon={byPrefixAndName.fasl['external-link-alt']} />
                                            package link
                                        </NwLink>
                                    </p>
                                    <p>
                                        <NwClipboardCopyText asLink label="Copy link" text={recipient.Link} />
                                    </p>
                                </div>
                                <div className="package-drawer-recipient-code">
                                    <p>code</p>
                                    <Text code>{recipient.Guid}</Text>
                                </div>
                            </div>
                            {recipient.Shortlists && recipient.Shortlists.length > 0 && (
                                <div className="package-drawer-recipient-shortlists">
                                    <div className="package-drawer-recipient-shortlists-summary">
                                        <p>{recipient.Shortlists.length} shortlists</p>
                                    </div>
                                    <div className="package-drawer-recipient-shortlists-list">
                                        {recipient.Shortlists.map((shortlist, index) => (
                                            <div className="package-drawer-recipient-shortlist" key={index}>
                                                <PackageShortlist
                                                    shortlist={shortlist}
                                                    onSelectItem={onSelectShortlistItem}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </NwCard>
            {selectedShortlistItem && (
                <ModelDrawer modelID={selectedShortlistItem} onClose={() => setSelectedShortlistItem(null)} />
            )}
        </div>
    );
};

export default PackageRecipientsSummary;
